export enum StatusName {
  None = 'none',
  Generating = 'generating',
  Ready = 'ready'
}
